import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function IdCell({ rowData: { id } }: CellProps) {
  const { searchString } = useSearchContext();
  return <HighlightText text={id} searchText={searchString} />;
}
